package org.gymly.data

import org.gymly.model.AdminWorker
import org.gymly.model.PickedImagePayload

/** Sube o elimina la foto del trabajador y sincroniza con terminales Hikvision activos. */
suspend fun AdminRepository.persistStaffPhotoAndSync(
    staffId: String,
    photo: PickedImagePayload? = null,
    removePhoto: Boolean = false,
): AdminWorker {
    if (removePhoto) {
        deleteWorkerPhoto(staffId)
    } else if (photo != null) {
        uploadWorkerPhoto(staffId, photo)
    }
    runCatching { syncStaffAccess(staffId) }
    return getWorker(staffId)
}
